module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14db1428fa1036e12731b39dfb449a22.png";